import { SgdfMeetingTable } from "./MeetingTable";
window.customElements.define("sgdf-meeting-table", SgdfMeetingTable);
//# sourceMappingURL=sgdf-meeting-table.js.map